import { useFormikContext } from 'formik';

import { UserType } from '../../../types/UserType';
import { FormikCustomerCompanyMultiSelect } from '../../common/form-elements/formik/FormikCustomerCompanyMultiSelect';
import { FormikSupplierCompanyMultiSelect } from '../../common/form-elements/formik/FormikSupplierCompanyMultiSelect';
import { translate } from '../../common/helpers/translate.helper';

import { FormikEditUserState } from './EditUserForm';

export const FormikEditUserFormCompanyMultiSelect = () => {
    const { values } = useFormikContext<FormikEditUserState>();
    const isCustomer = values.userType === UserType.CUSTOMER;

    if (isCustomer) {
        return (
            <FormikCustomerCompanyMultiSelect
                name="companyIds"
                groupId={values.groupId}
                label={translate('user.companies')}
            />
        );
    }

    return (
        <FormikSupplierCompanyMultiSelect
            name="companyIds"
            groupId={values.groupId}
            label={translate('user.companies')}
        />
    );
};
